import { FC } from 'react';
import { DiscountsList } from 'containers/discounts';
import { DiscountsLayout } from 'pages/atoms';

const DiscountsPage: FC = () => {
  return (
    <DiscountsLayout>
      <DiscountsList />
    </DiscountsLayout>
  );
};

export default DiscountsPage;
